import { Schema } from "effect";
export const UUIDV4 = Schema.String.annotations({
    title: "UUID",
    description: "Universally Unique Identifier"
});
